import { Inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InfoModalComponent } from '@modules/components-common';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

@Injectable({ providedIn: 'root' })
export class TicketDescriptionModalService {
  constructor(
    public dialog: MatDialog,
    @Inject(I18NEXT_SERVICE) private i18n: ITranslationService
  ) {}

  showModal(ticketAlias: string, title: string) {
    this.dialog.open(InfoModalComponent, {
      data: {
        title: title,
        markdown: `${ticketAlias}-modal`,
        showTicket: true,
      },
    });
  }

  flexible() {
    this.dialog.open(InfoModalComponent, {
      data: {
        title: this.i18n.t('flexible_tickets_title', {
          ns: 'translation',
        }),
        markdown: 'FLEXI-modal',
        showTicket: true,
      },
    });
  }

  payg() {
    this.dialog.open(InfoModalComponent, {
      data: {
        title: this.i18n.t('payg_tickets_title', {
          ns: 'translation',
        }),
        markdown: 'PAYG-modal',
        showTicket: true,
      },
    });
  }
}
